import React from "react"
import BaseIcon from "../../BaseIcon"

export default class ExpandAllIcon extends BaseIcon {
  getChildren = () => [
    <path
      fill={this.getColor()}
      d="M0,16V15H16v1ZM0,1H16V2H0ZM5,7,8,4l3,3m0,3L8,13,5,10"
    />,
  ]
  getViewBox = () => "0 0 16 16"
}
